'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosFlameOutline = function IoIosFlameOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm17.5 2.5c6.8 5 13.3 14 12.4 22.5-1 10.5-8.1 12.5-9.9 12.5s-9.9-3.1-10-12.5c-0.1-11.4 9.5-11.2 7.5-22.5z m2.5 34.4s3.1-2.8 3.1-6.3-3.1-6.2-3.1-6.2-3.2 2.8-3.2 6.2 3.2 6.3 3.2 6.3z m8.7-12.1c0.4-3.6-0.8-7.7-3.2-11.8-1.8-2.8-3.9-5.4-6.5-7.7 0 4.5-1.9 7.1-3.8 9.6-2.1 2.7-3.9 5.1-3.9 10.1 0 2 0.3 3.8 1.1 5.3 0.6 1.3 1.6 2.5 2.8 3.5 0.6 0.6 1.2 1 1.8 1.3-0.7-1.3-1.5-2.8-1.5-4.5 0-4 3.5-7 3.6-7.2l0.9-0.7 0.9 0.7c0.1 0.2 3.5 3.2 3.5 7.2 0 1.8-0.7 3.5-1.5 4.7 0.5-0.3 1-0.6 1.6-1.1 1-0.9 1.9-2.1 2.6-3.4 0.9-1.7 1.3-3.7 1.6-6z' })
        )
    );
};

exports.default = IoIosFlameOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-flame-outline.js
// module id = 2187
// module chunks = 0